import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { withTipiContratto } from "../withTipiContratto";
import { formGroup } from "../../common/components/formGroup";
import { TipoContratto } from "../../generated";

const DropdownList = Dropdown<TipoContratto>();
interface Props {
    data: TipoContratto[],
    value: TipoContratto | string | null,
    onChange: (type: TipoContratto | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __TipoContrattoSelector extends React.PureComponent<Props>{

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus } = this.props;
        return <DropdownList
            label={label ?? "Nome configurazione"}
            allowNull
            data={data}
            textField={x => x.descrizione ?? ""}
            onSelect={onChange}
            value={typeof value == "string" ? data.find(x => x.id == value) ?? null : value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export const TipoContrattoSelector = formGroup(withTipiContratto(__TipoContrattoSelector)(x => x.getall(), "data"))

